import type { SpotlightRect } from '../../../shared/ui/common/WorkspaceSpotlightTour';

export type QuickFillChromeControllerId =
  | 'quickfill-workspace-tab'
  | 'quickfill-guide'
  | 'quickfill-tour'
  | 'quickfill-theme'
  | 'quickfill-summary';

const HOST_RIBBON_HEIGHT = 34;
const HOST_RIBBON_TOP = 0;

interface ControllerLayout {
  leftOffset: number;
  width: number;
}

const controllerLayouts: Record<QuickFillChromeControllerId, ControllerLayout> = {
  'quickfill-workspace-tab': { leftOffset: 92, width: 94 },
  'quickfill-guide': { leftOffset: -172, width: 34 },
  'quickfill-tour': { leftOffset: -134, width: 34 },
  'quickfill-theme': { leftOffset: -96, width: 34 },
  'quickfill-summary': { leftOffset: -58, width: 34 },
};

export const getQuickFillChromeControllerRect = (
  id: QuickFillChromeControllerId,
  viewportWidth: number
): SpotlightRect => {
  const layout = controllerLayouts[id];
  const left = layout.leftOffset < 0 ? viewportWidth + layout.leftOffset : layout.leftOffset;

  return {
    top: HOST_RIBBON_TOP,
    left: Math.max(8, left),
    width: layout.width,
    height: HOST_RIBBON_HEIGHT,
  };
};

export const quickFillChromeControllers = (
  viewportWidth: number
): Record<QuickFillChromeControllerId, SpotlightRect> => ({
  'quickfill-workspace-tab': getQuickFillChromeControllerRect('quickfill-workspace-tab', viewportWidth),
  'quickfill-guide': getQuickFillChromeControllerRect('quickfill-guide', viewportWidth),
  'quickfill-tour': getQuickFillChromeControllerRect('quickfill-tour', viewportWidth),
  'quickfill-theme': getQuickFillChromeControllerRect('quickfill-theme', viewportWidth),
  'quickfill-summary': getQuickFillChromeControllerRect('quickfill-summary', viewportWidth),
});
